import { Box, Image, ListItem, OrderedList } from '@chakra-ui/react';

import { OnboardingCompanyProfile, UserProfile } from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import SunshineCard from 'components/_core/SunshineCard';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import Header from '../../components/Header';
import ToDo from './assets/ToDo.png';
import locales from './locales';

const MORE_INFO_URL =
  'https://help.shine.fr/fr/articles/4305211-qu-est-ce-qu-un-beneficiaire-effectif';

interface WelcomeInviteeProps {
  profile: Pick<UserProfile, 'firstName'>;
  companyProfile: Pick<OnboardingCompanyProfile, 'legalName'>;
  isAccountHolder: boolean;
  onContinue: () => void;
}

/**
 * A non-interactive page welcoming an invited beneficiary
 */
const WelcomeInvitee = asBentoPage<WelcomeInviteeProps>(
  ({ companyProfile, isAccountHolder, Layout, onContinue, profile }) => {
    const steps = [
      ...locales.steps,
      ...(isAccountHolder ? locales.additionalSteps : []),
    ];

    const linkProps = {
      linkText: locales.moreInfoLink,
      linkUrl: MORE_INFO_URL,
    };

    return (
      <Layout nav={<OBNavigation />}>
        <Box>
          <Header
            description={locales.formatString(locales.page.subtitle, {
              companyName: companyProfile.legalName,
            })}
            title={locales.formatString(locales.page.title, {
              name: profile.firstName ?? '',
            })}
            {...(isAccountHolder ? {} : linkProps)}
          />

          <SunshineCard.Group>
            <SunshineCard title={locales.stepsTitle}>
              <SunshineCard.Slot name="aside">
                <Image boxSize="60px" src={ToDo} />
              </SunshineCard.Slot>

              <SunshineCard.Content>
                <OrderedList>
                  {steps.map((step) => (
                    <ListItem key={step}>
                      <SunshineCard.Text>{step}</SunshineCard.Text>
                    </ListItem>
                  ))}
                </OrderedList>
              </SunshineCard.Content>
            </SunshineCard>

            <SunshineCard textAlign="center">
              <Button icon="arrow-right" isExpanded onClick={onContinue}>
                {locales.cta}
              </Button>
            </SunshineCard>
          </SunshineCard.Group>
        </Box>
      </Layout>
    );
  },
);

export default WelcomeInvitee;
